import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { WorkFrontService } from '../proxy/controlling/controllers/work-front.service';
import { PersonService } from '@general/proxy/general/controllers/person.service';

FieldBuilder.setNamespace('Controlling');

export const PERSONPERWORKFRONT_FIELDS: FieldDefinition[] = [
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('personId', 'Entity.PersonPerWorkFront.Person', PersonService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),
  FieldBuilder
    .foreignKey('workFrontId', 'Entity.WorkFront', WorkFrontService)
    .required()
    .displayFromNested('workFront.name') 
    .sortBy('workFront.name') 
    .hideInChildForms()
    .build(),
];

export const PERSONPERWORKFRONT_CONFIG = {
  entityName: 'PersonPerWorkFront',
  localizationKey: 'Controlling::Entity.PersonPerWorkFront',
  fields: PERSONPERWORKFRONT_FIELDS,
  permission: 'ControllingStructural.PersonPerWorkFronts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
